import { Box, Paper, Stack, Typography } from '@mui/material';

export function ResultCard({ title, children }) {
  return (
    <>
      <Paper elevation={2} sx={{ padding: '20px', width: '500px', height: '520px' }}>
        <Stack direction="column" spacing={2} sx={{ height: '100%' }}>
          <Stack direction="row" justifyContent="center">
            <Typography variant="h6" color="textPrimary" component="h6">
              {title}
            </Typography>
          </Stack>
          <Stack justifyContent="center" sx={{ height: '100%' }} direction="column" spacing={2}>
            <Box>{children}</Box>
          </Stack>
        </Stack>
      </Paper>
    </>
  );
}
